<template>
    <div id="dealer-page">
        <section-definition
            :title="page.title"
            :menuItems="menuItems"
        >
           <v-autocomplete
               label="Curriculum Type"
               :items="['All', 'GradedLead', 'CoachUp']"
               v-model="curriculum_type"
               style="max-width: 200px"
               @change="on_type_change"
           />
        </section-definition>


        <my-show-error
                v-model="dialog_show_error"
                :error="show_error_obj"
        ></my-show-error>

        <!----------------------Curriculum Dialog----------------------------------------------------------------------->
        <v-dialog v-model="dialog_c" persistent max-width="1200px" attach="#dealer-page" >
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle_c }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form_c">
                        <v-container fluid grid-list-md page>
                            <v-layout wrap>
                                <v-flex xs12 sm12 md6>
                                    <v-text-field
                                            label="Curriculum Name*"
                                            v-model="editedItem_c.name"
                                            :rules="[x=>isRequired(x, 'Name')]"></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm2 md1>
                                    <v-select
                                            :items="['1', '2', '3', '4']"
                                            label="Level*"
                                            v-model="editedItem_c.level"
                                            :rules="[x=>isRequired(x, 'Level')]"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm2 md2>
                                    <v-select
                                       :items="['INTERNET', 'PHONE', 'SHOWROOM']"
                                       label="Email Template*"
                                       v-model="editedItem_c.email_template"
                                       :rules="[x=>isRequired(x, 'Email Template')]"
                                    ></v-select>
                                </v-flex>

                               <v-flex xs12 sm2 md2>
                                  <v-select
                                      :items="['GradedLead', 'CoachUp']"
                                      label="Type*"
                                      v-model="editedItem_c.type"
                                      :rules="[x=>isRequired(x, 'Type')]"
                                  ></v-select>
                               </v-flex>

                                <v-flex xs12 sm2 md1>
                                    <v-select
                                            :items="[{text:'Yes', value:true}, {text:'No', value:false}]"
                                            label="Active?"
                                            v-model="editedItem_c.is_active"
                                            item-value="value"
                                            item-text="text"
                                            rows="2"
                                            required
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field
                                        label="Notes"
                                        v-model="editedItem_c.notes"
                                        hint="Describe this curriculum"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <draggable
                                        v-model="editedItem_c.questions"
                                        group="questions"
                                        @start="drag=true"
                                        @end="drag=false"
                                        ghostClass="dragged"
                                        handle=".v-input__prepend-outer"
                                    >
                                        <v-layout
                                            v-for="(value, i) in editedItem_c.questions"
                                            :key="i"
                                        >
                                            <v-flex xs8 sm10 md10>
                                                <v-autocomplete
                                                    :label="'Question '+(i+1)+'*'"
                                                    :items="questions"
                                                    item-value="_id"
                                                    item-text="txt"
                                                    v-model="editedItem_c.questions[i].q_id"
                                                    :rules="[x=>isRequired(x, 'Question')]"
                                                    prepend-icon="sort"
                                                    append-outer-icon="edit"
                                                    @click:append-outer="editQuestion(editedItem_c.questions[i].q_id)"
                                                ></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs4 sm2 md2>
                                                <v-text-field

                                                    :label="'Weight'"
                                                    v-model="editedItem_c.questions[i].weight"
                                                    append-outer-icon="clear"
                                                    @click:append-outer="editedItem_c.questions.splice(i, 1)"
                                                    hint="Should sum to 100."
                                                    :rules="[isNumber]"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                    </draggable>

                                </v-flex>

                                <v-flex xs8 sm10 md10 class="no-margin">
                                    <v-checkbox
                                            id="check-weight-override"
                                            v-model="ignore_weight_check"
                                            label="Over-ride weights=100 Check?"
                                            hide-details
                                    ></v-checkbox>
                                    <div v-if="ignore_weight_check" class="red--text">
                                        Warning: Not enforcing total = 100.  Please verify total weight is correct before saving.
                                    </div>
                                    <div v-if="cur_c_has_exclusion_q" class="red--text">
                                        Note: Dependent Question(s) Detected.
                                    </div>

                                </v-flex>
                                <v-flex grow v-bind:class="get_sum_class()">{{sum_weights}} (Total)</v-flex>
                                <v-flex shrink>
                                    <v-icon v-on:click="editedItem_c.questions.push({question: '', weight:'0'})">add</v-icon>
                                </v-flex>

                                <!----------------grading scale--------------------------->
                                <v-expansion-panel class="mt-3">
                                    <v-expansion-panel-content>
                                        <template v-slot:header>
                                            <div>Edit Grade Ranges</div>
                                        </template>

                                        <v-card>
                                            <v-card-text>
                                                Note that grade ranges are:  low_range &#8805; score > high range
                                            </v-card-text>
                                            <v-card-text>
                                                <template v-for="(value, i) in editedItem_c.grading_scale" >
                                                    <v-layout :key="i">
                                                        <v-flex xs8 sm6 md6>
                                                            <v-autocomplete
                                                                    :label="'Low Range: ' + editedItem_c.grading_scale[i].grade"
                                                                    :items="score_list"
                                                                    v-model="editedItem_c.grading_scale[i].score_low"
                                                                    hide-details
                                                            ></v-autocomplete>
                                                        </v-flex>
                                                        <v-flex xs8 sm6 md6>
                                                            <v-autocomplete
                                                                    :label="'High Range: ' + editedItem_c.grading_scale[i].grade"
                                                                    :items="score_list"
                                                                    v-model="editedItem_c.grading_scale[i].score_high"
                                                            ></v-autocomplete>
                                                        </v-flex>

                                                    </v-layout>
                                                </template>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>


                                <!----------------report card settings--------------------------->
                                <v-expansion-panel class="mt-3">
                                    <v-expansion-panel-content>
                                        <template v-slot:header>
                                            <div>Edit Report Card Settings</div>
                                        </template>

                                        <v-card class="pl-2 pr-2">
                                            <v-card-text>

                                                <reportcard-setting
                                                   v-for="(item, ix) in editedItem_c.report_card"
                                                   :key="item.section_name"
                                                   :rc_section="editedItem_c.report_card[ix]"
                                                   :heading.sync="editedItem_c.report_card[ix].section_name"
                                                   :questions="editItem_rc_questions"
                                                ></reportcard-setting>


                                            </v-card-text>

                                        </v-card>

                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <!----------------End report card settings--------------------------->


                            </v-layout>
                        </v-container>
                    </v-form>

                </v-card-text>

                <v-layout row v-if="form_error_c">
                    <!--<v-flex grow></v-flex>-->
                    <v-spacer></v-spacer>
                    <v-flex shrink class="pr-3 red--text"> {{form_error_c}}</v-flex>
                </v-layout>
                <v-card-actions>
                    <v-btn color="primary" :disabled="saving_curriculum" @click="save_c(true)">Duplicate</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="saving_curriculum" @click="close_c(1)">Cancel</v-btn>
                    <v-btn color="primary" :disabled="saving_curriculum" @click="save_c(false)">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <!----------------------Question Dialog----------------------------------------------------------------------->
        <v-dialog v-model="dialog_q" persistent max-width="700px" attach="#dealer-page" >
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle_q }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form_q">
                        <v-container fluid grid-list-md page>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md7>
                                    <v-text-field
                                        label="Name*"
                                        v-model="editedItem_q.title"
                                        :rules="[x => isRequired(x, 'Name')]"
                                    ></v-text-field>
                                </v-flex>
                               <v-flex xs12 sm2 md3>
                                  <v-select
                                      :items="['GradedLead', 'CoachUp']"
                                      label="Type*"
                                      v-model="editedItem_q.type"
                                      :rules="[x=>isRequired(x, 'Type')]"
                                  ></v-select>
                               </v-flex>
                                <v-flex xs12 sm6 md2>
                                    <v-select
                                        :items="[{text:'Yes', value:true}, {text:'No', value:false}]"
                                        label="Active?"
                                        v-model="editedItem_q.is_active"
                                        item-value="value"
                                        item-text="text"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field
                                        label="Tags"
                                        v-model="editedItem_q.tags_str"
                                        hint="Enter comma separated list of tags"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-textarea
                                        v-model="editedItem_q.question"
                                        label="Question*"
                                        :rules="[x => isRequired(x, 'Question')]"
                                        style="border-width: thin; "
                                        rows="2"
                                    ></v-textarea>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <!--<v-checkbox-->
                                    <!--label="Is this question's answer based on other questions?"-->
                                    <!--v-model="q_is_linked"-->
                                    <!--&gt;</v-checkbox>-->


                                    <v-select
                                            :items="[{text:'Yes', value:true}, {text:'No', value:false}]"
                                            label="Depends on other questions?"
                                            v-model="q_is_linked"
                                            item-value="value"
                                            item-text="text"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-select
                                            :items="link_types"
                                            label="Link Type*"
                                            v-model="editedItem_q.linked_questions.link_type"
                                            item-value="value"
                                            item-text="text"
                                            v-if="q_is_linked"
                                            :rules="[x => isRequired(x, 'Type', !q_is_linked)]"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-select
                                            :items="['SUM', 'DIFFERENCE', 'PRODUCT', 'RATIO' ]"
                                            label="Functional Relationship*"
                                            v-model="editedItem_q.linked_questions.function"
                                            item-value="value"
                                            item-text="text"
                                            v-if="q_is_linked && editedItem_q.linked_questions.link_type ==='FunctionOf'"
                                            :rules="[x => isRequired(x, 'Relationship', !q_is_linked)]"
                                    ></v-select>
                                </v-flex>

                                <v-flex
                                    xs12
                                    v-if="q_is_linked"
                                >
                                    <draggable
                                        v-model="editedItem_q.linked_questions.inputs"
                                        group="linked_answers"
                                        @start="drag=true"
                                        @end="drag=false"
                                        ghostClass="dragged"
                                    >
                                        <template v-for="(value, i) in editedItem_q.linked_questions.inputs" >
                                            <v-layout wrap :key="i">
                                                <v-flex md8 v-if="editedItem_q.linked_questions.link_type==='DependsOn'">
                                                    <v-autocomplete
                                                        :items="questions"
                                                        item-value="_id"
                                                        item-text="txt"
                                                        v-model="editedItem_q.linked_questions.inputs[i].q_id"
                                                        :label="'Linked Question '+(i+1)+'*'"
                                                        :rules="[x => isRequired(x, 'Linked Question')]"
                                                        @change="on_linked_input_selected(i)"
                                                    ></v-autocomplete>
                                                </v-flex>
                                                <v-flex md4 v-if="editedItem_q.linked_questions.link_type==='DependsOn'">
                                                    <v-autocomplete
                                                            :items="editedItem_q.answers"
                                                            item-value="ans"
                                                            item-text="ans"
                                                            v-model="editedItem_q.linked_questions.inputs[i].ans_to_set"
                                                            :label="'This Answer '+(i+1)+'*'"
                                                            :rules="[x => isRequired(x, 'Set Ans')]"

                                                    ></v-autocomplete>
                                                </v-flex>
                                                <v-flex md12 v-if="editedItem_q.linked_questions.link_type ==='DependsOn'">
                                                    <v-combobox
                                                            :items="editedItem_q.linked_questions.inputs[i].ans_list"
                                                            item-value="ans"
                                                            item-text="ans"
                                                            v-model="editedItem_q.linked_questions.inputs[i].if_these"
                                                            :label="'Input Answer '+(i+1)+'*'"
                                                            :rules="[x => isRequired(x, 'Input Answers')]"
                                                            append-outer-icon="clear"
                                                            @click:append-outer="del_linked_input(i)"
                                                            :return-object="false"
                                                            chips
                                                            deletable-chips
                                                            multiple
                                                    ></v-combobox>
                                                </v-flex>



                                                <v-flex md12 v-else>
                                                    <v-autocomplete
                                                            :items="questions"
                                                            item-value="_id"
                                                            item-text="txt"
                                                            v-model="editedItem_q.linked_questions.inputs[i].q_id"
                                                            :label="'Linked Question '+(i+1)+'*'"
                                                            :rules="[x => isRequired(x, 'Linked Question')]"
                                                            @change="on_linked_input_selected(i)"
                                                            append-outer-icon="clear"
                                                            @click:append-outer="del_linked_input(i)"
                                                    ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </template>
                                    </draggable>
                                </v-flex>

                                <v-flex grow v-if="q_is_linked"></v-flex>
                                <v-flex shrink v-if="q_is_linked">
                                    Add Linked Question
                                </v-flex>
                                <v-flex shrink v-if="q_is_linked">
                                    <v-icon v-on:click="add_linked_input">add</v-icon>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-divider v-if="q_is_linked"></v-divider>

                                    <draggable
                                            v-model="editedItem_q.answers"
                                            group="answers"
                                            @start="drag=true"
                                            @end="drag=false"
                                            ghostClass="dragged"
                                            handle=".v-input__prepend-outer"
                                    >
                                        <template v-for="(value, i) in editedItem_q.answers" >
                                            <v-layout :key="i">
                                                <v-flex md7>
                                                    <v-text-field
                                                            v-model="editedItem_q.answers[i].ans"
                                                            :label="'Answer '+(i+1)+'*'"
                                                            :rules="[x => isRequired(x, 'Answer')]"
                                                            prepend-icon="sort"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex md2>
                                                    <v-autocomplete
                                                            label="Is N/A"
                                                            v-model="editedItem_q.answers[i].ansIsNA"
                                                            :items="[{txt: 'Yes', value: true}, {txt: 'No', value: false}]"
                                                            item-text="txt"
                                                            item-value="value"

                                                    ></v-autocomplete>
                                                </v-flex>

                                                <v-flex md3>
                                                    <v-text-field
                                                        v-model="editedItem_q.answers[i].score"
                                                        label="Score*"
                                                        append-outer-icon="clear"
                                                        @click:append-outer="editedItem_q.answers.splice(i, 1)"
                                                        hint="Should be in [0, 1] or -1 for N/A"
                                                        :rules="[x=>checkRange(x, 0, 1, [-1])]"
                                                    ></v-text-field>
                                                </v-flex>



                                            </v-layout>
                                        </template>
                                    </draggable>

                                </v-flex>
                                <v-flex grow></v-flex>
                                <v-flex shrink>
                                    Add Answer
                                </v-flex>
                                <v-flex shrink>
                                    <v-icon v-on:click="editedItem_q.answers.push({ans: '', score:'0'})">add</v-icon>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-form>



                    <v-layout row v-if="form_error_q">
                        <!--<v-flex grow></v-flex>-->
                        <v-spacer></v-spacer>
                        <v-flex shrink class="pr-3 red--text"> {{form_error_q}}</v-flex>

                    </v-layout>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close_q">Cancel</v-btn>
                    <v-btn color="primary"  @click="save_q">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>






        <!--Curriculum Table------------------------------------------------------------------------------------------->
        <v-container fluid grid-list-xl page>
            <v-card-title  >
                <v-btn color="primary" dark class="mb-2" v-on:click="newItem_c">Add Curriculum</v-btn>
                <!--<v-switch-->
                        <!--v-model="showOnlyActive_c"-->
                        <!--:label="'Show only Active Curricula'"-->
                        <!--color="primary"-->
                        <!--v-on:change="get_curricula"-->
                <!--&gt;</v-switch>-->

                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search_txt_c"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>

            <v-data-table
                :headers="headers_c"
                :items="curricula"
                :search="search_txt_c"
                :rows-per-page-items="pagination_c"
                class="elevation-1 border-radius6"
                :loading="data_loading_c"
            >
                <template slot="items" slot-scope="props">
                    <tr v-bind:class="get_row_class(props.item.is_active)"
                        class="row"
                        @click="editItem_c(props.item)"
                        :key="props.item._id"
                    >
                        <td>{{ props.item.level }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ questions_to_str(props.item.questions) }}</td>
                        <td>{{ props.item.is_active ? 'Yes' : 'No' }}</td>
                    </tr>

                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search_txt_c }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
        </v-container>



        <!---------------------Questions Table------------------------------------------------------------------------>
        <v-container fluid grid-list-xl page>
            <v-card-title  >
                <v-btn color="primary" dark class="mb-2" v-on:click="newItem_q">Add Question</v-btn>
                <!--<v-switch-->
                        <!--v-model="showOnlyActive_q"-->
                        <!--:label="'Show only Active Questions'"-->
                        <!--color="primary"-->
                        <!--v-on:change="get_questions"-->
                <!--&gt;</v-switch>-->

                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search_txt_q"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>

            <v-data-table
                    :headers="headers_q"
                    :items="questions"
                    :search="search_txt_q"
                    :rows-per-page-items="pagination_q"
                    class="elevation-1 border-radius6"
                    :loading="data_loading_q"
            >
                <template slot="items" slot-scope="props">
                    <tr v-bind:class="get_row_class(props.item.is_active)"
                        class="row"
                        @click="editItem_q(props.item)"
                        :key="props.item._id"
                    >
                        <td>{{ props.item.num_id }}</td>
                        <td>{{ props.item.title }}</td>
                        <td>{{ props.item.question }}</td>
                        <td>{{ props.item.is_active ? 'Yes' : 'No' }}</td>
                        <td class="justify-center">
                            <div v-if="props.item.linked_questions !== null">
                                <!--<v-icon small class="mr-2" >attach_file</v-icon>-->
                                {{linked_text(props.item)}}
                            </div>

                        </td>
                    </tr>
                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search_txt_q }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>

        </v-container>

    </div>
</template>

<style scoped>
    .row_inactive {
        color: #b8b8b8;
    }
    .error_txt{
        color: red;
    }

    .row{
        cursor: pointer;
    }
    .dragged{
        background-color: #cbcbcb;
    }

    .rc-header{
        font-size: medium;
        font-weight: bold;
    }

    .v-form .container .layout .flex{
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .no-margin{

    }

    /*.v-form .container .layout .flex.no-margin .v-input{*/
        /*margin-top: 0px;*/
        /*padding-top: 0px;*/
        /*padding-bottom: 0px;*/
    /*}*/


</style>


<script>
   import axios from 'axios';
   import draggable from 'vuedraggable'

   import validate from '../mixins/validation';
   import data_getters from '../mixins/data_getters'
   import reportcardSetting from '../components/reportcardSetting.vue';

   //https://stackoverflow.com/questions/7176908/how-to-get-index-of-object-by-its-property-in-javascript/54015295
   // function findWithAttr(array, attr, value) {
   //
   //    for(var i = 0; i < array.length; i += 1) {
   //       if(array[i][attr] === value) {
   //          return i;
   //       }
   //    }
   //    return -1;
   // }

   let grading_scale = [
         {grade: 'A+', score_low:97, score_high:100},
         {grade: 'A', score_low:93, score_high:97},
         {grade: 'A-', score_low:90, score_high:93},
         {grade: 'B+', score_low:87, score_high:90},
         {grade: 'B', score_low:83, score_high:87},
         {grade: 'B-', score_low:80, score_high:83},
         {grade: 'C+', score_low:77, score_high:80},
         {grade: 'C', score_low:73, score_high:77},
         {grade: 'C-', score_low:70, score_high:73},
         {grade: 'D+', score_low:67, score_high:70},
         {grade: 'D', score_low:63, score_high:67},
         {grade: 'D-', score_low:60, score_high:63},
         {grade: 'F', score_low:0, score_high:60}
   ];


   let default_form_c = { // this item should never be changed
      name: '',
      questions:[{q_id: null, weight:'0'}],
      level: 1,
      is_active: true,
      grading_scale: grading_scale,
      agency_id: '',
      notes:'',
      report_card: [
         {section_name: 'Timing', questions:[]},
         {section_name: 'Content', questions:[]},
         {section_name: 'Value', questions:[]},
         {section_name: 'Engagement', questions:[]},
         {section_name: 'Effort', questions:[]},
         {section_name: 'Results', questions:[]},

      ]
   };


   let default_form_q = { // this item should never be changed
      title: '',
      question: '',
      answers: [{ans: '', score:'0'}],
      level: 1,
      is_active: true,
      linked_questions: {inputs: [{q_id:null}], function:''},
      tags_str: '',
      tags: [],
      agency_id: ''
   };


   export default {
      name: 'ManageQuestions',
      mixins: [data_getters, validate],
      components: {draggable, reportcardSetting},

      data() {
         return {

            drag: false,
            curriculum_type: 'All',

            //variables for curricula*********************************************************************************
            headers_c: [
               {text: 'Level', value:'level', width: "5%"},
               {text: 'Curriculum', value:'name', width: "20%"},
               {text: 'Questions', value:'question', width: "70%"},
               {text: 'Active?', value:'is_active', width: "10%"},
               // {text: 'Edit', value:"" },
            ],

            curricula: [],
            pagination_c: [25, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            showOnlyActive_c: false,
            form_error_c: null,

            data_loading_c: false,

            //search bar
            search_txt_c: '',
            score_list: [],

            weight_sum: 0,
            ignore_weight_check: false, //used to indicate if we should enforece weights == 100 or not
            dependent_q_found: false,

            //add new/edit question dialog
            formTitle_c: 'Add New Curriculum',
            dialog_c: false,
            editedIndex_c: -1,
            editedItem_c: JSON.parse(JSON.stringify(default_form_c)), //Object.assign({}, default_form_c),
            editItem_rc_questions: [], //curiculum questions to used for report cord drop down list


            //variables for questions***********************************************************************************
            headers_q: [
               {text: 'ID', value: 'num_id', width: "5%"},
               {text: 'Title', value:'title', width: "20%"},
               {text: 'Question', value:'question', width: "65%"},
               {text: 'Active', value:'is_active', width: "5%"},
               {text: 'Linked?', value:"", width: "15%" },
            ],

            link_types: [
               {text: 'Depends On', value: 'DependsOn'},
               {text: 'Exclude On', value: 'ExcludeOn'},
               {text: 'Function Of', value: 'FunctionOf'}
            ],

            data_loading_q: false,
            questions: [],
            questions_hash: {}, //used to hash id to array pos to speed up searches
            pagination_q: [25, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            showOnlyActive_q: false,
            q_is_linked: false,


            form_error_q: null,

            //search bar
            search_txt_q: '',

            //add new/edit question dialog
            formTitle_q: 'Add New Question',
            dialog_q: false,
            editedIndex_q: -1,
            editedItem_q: JSON.parse(JSON.stringify(default_form_q)), //Object.assign({}, default_form_q),


            //main page header
            page: {
               title: "Manage Curriculum",
               headline: "Black Page",
            },
            menuItems: [
               {title: "Only Show Active Accounts", value: true}
            ],


            saving_curriculum: false,


         };
      },
      methods:{

         on_type_change(){
           this.get_curricula_local().catch(e=>{console.error(e)});
            this.get_questions_local().catch(e=>{console.error(e)});
         },

         get_row_class(is_active){
            if (is_active){
                return 'row_active';
            }
            else{
               return 'row_inactive';
            }
         },

         get_sum_class(){
            if (this.sum_weights !=100){
               return 'red--text';
            }
            else{
               return 'a-class';
            }
         },


         /**
          * returns the array index of a question, given it's id
          */
         get_q_ix(q_id){
           let ix =  this.questions_hash[q_id];

           if (ix == undefined){
              return -1;
           }
           return ix;
         },

         //*************for curricula***********************************************************************************

         async get_curricula_local(){
            this.data_loading_c = true;
            this.curricula = await this.get_curricula({get_rc_data: true, c_type: this.curriculum_type});
            this.data_loading_c = false;
         },

         close_c () {
            this.dialog_c = false;
            setTimeout(() => {
               this.editedItem_c = JSON.parse(JSON.stringify(default_form_c));
               this.editedIndex_c = -1;
               this.formTitle_c = 'Add New Curriculum';
               this.form_error_c = null;
               this.$refs.form_c.resetValidation();
            }, 300)
         },

         newItem_c(){
            if (this.$auth.profile.user_role !== 'SuperAdmin'){
               this.editedItem_c.agency_id = this.$auth.profile.agency_id;
            }


            this.dialog_c = true;
         },

         editItem_c (item) {
            this.dialog_c = true;
            this.formTitle_c = 'Edit Curriculum';
            this.editedIndex_c = this.findWithAttr(this.curricula, '_id', item._id);
            this.editedItem_c = JSON.parse(JSON.stringify(item)); // Object.assign({}, item);
            this.update_rc_q_list();
            this.ignore_weight_check = false;
            this.dependent_q_found = false;

         },



         async save_c (duplicate=false) {
            // let post_data = JSON.parse(JSON.stringify(this.editedItem_q));
            this.saving_curriculum = true;

            // if (!this.$refs.form_c.validate() || (this.sum_weights != 100 && !this.cur_c_has_exclusion_q)){
            //    this.form_error_c = 'Please check highlighed fields';
            //    this.saving_curriculum = false;
            //    return;
            //
            // }



            //getting rid of 100% check
            if (!this.$refs.form_c.validate() || (this.sum_weights != 100 && !this.ignore_weight_check)){
               this.form_error_c = 'Please check highlighed fields';
               this.saving_curriculum = false;
               return;

            }

            let post_data = {
               _id: this.editedItem_c._id,
               name: this.editedItem_c.name,
               questions: this.editedItem_c.questions,
               level: this.editedItem_c.level,
               is_active: this.editedItem_c.is_active,
               grading_scale: this.editedItem_c.grading_scale,
               agency_id: this.editedItem_c.agency_id,
               notes: this.editedItem_c.notes,
               report_card: this.editedItem_c.report_card,
               email_template: this.editedItem_c.email_template,
               type: this.editedItem_c.type
            };

            if (duplicate){
               delete post_data._id;
               post_data.name += '(Copy)'
            }



            //convert report card benchmark values to array from string
            let keys = Object.getOwnPropertyNames(post_data.report_card);

            for (let i=0; i<keys.length; i++){
               let list = post_data.report_card[keys[i]];

               for(let j=0; j<list.length; j++){
                  let tmp;
                  try{
                     tmp = JSON.parse(post_data.report_card[keys[i]][j].benchmark);
                  }
                  catch(e){
                     // tmp = [];
                     // console.log(`benchmark value of "${post_data.report_card[keys[i]][j].benchmark}" converted to empty array`);
                     // post_data.report_card[keys[i]][j].benchmark = '[]';
                     // console.log(e);

                     console.log('benchmark value is not a parsable json array')

                  }
                  // post_data.report_card[keys[i]][j].benchmark = tmp;
               }
            }

            console.log(post_data);

            //save to db
            try {
               // console.log(post_data);
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/updateCurriculum';
               var res = await axios.post(url, post_data, token);

               // refresh data from db
               await this.get_curricula_local();
               this.close_c();
            }
            catch(err){
               let tmp = this.show_error_details(err, 'save_c() on ManageQuestions page');
               console.log(tmp);
               this.form_error_c = tmp;
               // this.form_error_c = 'There was an error saving';
            }
            this.saving_curriculum = false;

         },

         /**
          * @param questions - array of question _id's
          */
         questions_to_str(questions){

            let ans = '';
            let ix;
            for (let i=0; i<questions.length; i++){
               // ix = this.findWithAttr(this.questions, '_id', questions[i].q_id);
               ix = this.get_q_ix(questions[i].q_id);
               if (ix > -1)
                  ans += (this.questions[ix].title+', ');

            }

            return ans;
         },


         update_rc_q_list(){
            this.editItem_rc_questions = [];
            for (let i=0; i< this.editedItem_c.questions.length; i++){
               // let ix = this.findWithAttr(this.questions, '_id', this.editedItem_c.questions[i].q_id);
               let ix = this.get_q_ix(this.editedItem_c.questions[i].q_id)
               let q = this.questions[ix];
               // this.editItem_rc_questions.push({_id: q._id, question: q.question})
               this.editItem_rc_questions.push({_id: q._id, question: q.txt})
            }
         },


         //*************for questions***********************************************************************************

         async get_questions_local(){
            this.data_loading_q = true;
            this.questions = await this.get_questions({q_type: this.curriculum_type});


            //create hash table to quickly map q_id's to array positions
            this.questions_hash = {};
            for (let i=0; i<this.questions.length; i++) {
               this.questions_hash[this.questions[i]._id] = i;
            }


            //add "txt" property to questions
            for (let i=0; i<this.questions.length; i++){

               this.questions[i].txt = '(Q'+this.questions[i].num_id + ') ' + this.questions[i].question;
               if (this.questions[i].linked_questions != null){
                  this.questions[i].txt += ' (' + this.linked_text(this.questions[i]) + ')';
               }

            }
            this.data_loading_q = false;
         },

         on_linked_input_selected(i){
            let ix = this.findWithAttr(this.questions, '_id', this.editedItem_q.linked_questions.inputs[i].q_id);
            this.editedItem_q.linked_questions.inputs[i].ans_list = this.questions[ix].answers;
         },

         del_linked_input(i){
            this.editedItem_q.linked_questions.inputs.splice(i, 1);
            // this.linked_q_answers.splice(i, 1);
         },

         add_linked_input(){
            this.editedItem_q.linked_questions.inputs.push({q_id: null, if_these: [], ans_to_set: null, ans_list:[]})
            //note ans_list is a temp array which holds the answer corresponding to editedItem_q.linked_questions.inputs[i].q_id
         },


         close_q () {
            this.dialog_q = false;
            setTimeout(() => {
               this.editedItem_q = JSON.parse(JSON.stringify(default_form_q)); //Object.assign({}, default_form_q);
               this.editedIndex_q = -1;
               this.formTitle_q = 'Add New Question';
               this.form_error_q = null;
               this.q_is_linked = false;
               this.$refs.form_q.resetValidation();
            }, 300)
         },
         newItem_q(){
            if (this.$auth.profile.user_role !== 'SuperAdmin'){
               this.editedItem_q.agency_id = this.$auth.profile.agency_id;
            }
            this.dialog_q = true;
         },



         /**
          * edit question from curriculum
          */
         editQuestion(q_id){

            let ix = this.findWithAttr(this.questions, '_id', q_id);
            if (ix > -1){
               this.editItem_q(this.questions[ix]);
            }
         },

         editItem_q (item) {
            this.formTitle_q = 'Edit Question Q' + item.num_id ;
            this.editedIndex_q = this.questions.indexOf(item);
            this.editedItem_q = JSON.parse(JSON.stringify(item)); //Object.assign({}, item);
            this.editedItem_q.tags_str = this.editedItem_q.tags  ? this.editedItem_q.tags.join(', '): '';


            if (this.editedItem_q.linked_questions === null){
               this.editedItem_q.linked_questions = {inputs: [], function:null, link_type: null};
               this.add_linked_input();
               this.q_is_linked = false;
            }
            else{
               this.q_is_linked = true;
               for (let i=0; i<this.editedItem_q.linked_questions.inputs.length; i++){
                  let ix = this.findWithAttr(this.questions, '_id', this.editedItem_q.linked_questions.inputs[i].q_id);
                  this.editedItem_q.linked_questions.inputs[i].ans_list = this.questions[ix].answers;
               }
            }





            this.dialog_q = true;
         },

         async save_q () {
            // let post_data = JSON.parse(JSON.stringify(this.editedItem_q));

            this.form_error_q = null;
            if (!this.$refs.form_q.validate() ){
               this.form_error_q = 'Please check highlighted fields';
               return;
            }




            //save to db
            try {
               //convert comma separated list into array
               this.editedItem_q.tags = this.editedItem_q.tags_str.split(',');
               if (this.editedItem_q.tags.length === 1 && this.editedItem_q.tags[0] == '')
                  this.editedItem_q.tags = [];

               for (let i=0; i<this.editedItem_q.tags.length; i++){
                  this.editedItem_q.tags[i] = this.editedItem_q.tags[i].trim();
               }

               if (this.q_is_linked === false ){
                  this.editedItem_q.linked_questions = null;
               }


               let post_data = {
                  _id: this.editedItem_q._id,
                  title: this.editedItem_q.title,
                  question: this.editedItem_q.question,
                  answers: this.editedItem_q.answers,
                  tags: this.editedItem_q.tags,
                  level: null,
                  is_active: this.editedItem_q.is_active,
                  agency_id: this.editedItem_q.agency_id,
                  linked_questions: this.editedItem_q.linked_questions,
                  type: this.editedItem_q.type
               };


               if (this.q_is_linked === false ){
                  this.editedItem_q.linked_questions = null;
               }
               else {
                  for (let i=0; i<post_data.linked_questions.inputs.length; i++){
                     delete post_data.linked_questions.inputs[i].ans_list;
                  }
               }

               console.log(post_data)

               // console.log(post_data);
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/updateQuestion';
               var res = await axios.post(url, post_data, token);

               // refresh data from db
               await this.get_questions_local();
               this.close_q();
            }
            catch(err){
               let tmp = this.show_error_details(err, 'save_q()');
               console.log(tmp);
               this.form_error_q = tmp;
            }

         },

         linked_text(item){
            let ans = '';
            if(item.linked_questions !== null ) {
               ans = item.linked_questions.link_type + ':';

               if (item.linked_questions.link_type === 'FunctionOf' )
                  ans = item.linked_questions.function + ':';

               for (let i=0; i<item.linked_questions.inputs.length; i++){
                  // let ix = this.findWithAttr(this.questions, '_id', item.linked_questions.inputs[i].q_id );
                  let ix = this.get_q_ix(item.linked_questions.inputs[i].q_id);

                  // console.log('linked q, inputs', item.linked_questions.inputs )
                  if (i>0) ans += ',';
                  ans += (' Q'+this.questions[ix].num_id);
               }
            }
            return ans;
         },


         //*************************************************************************************************************
         deleteItem (item) {
            const index = this.dealers.indexOf(item);
            confirm('Are you sure you want to delete this item?') && this.dealers.splice(index, 1)
         },
      },

      computed:{
         sum_weights: function(){
            let ans = 0.0;
            let n = this.editedItem_c.questions.length;

            for (let i=0; i<n; i++){
               ans += Number(this.editedItem_c.questions[i].weight);
            }
            return this.round(ans, 4);
         },

         /**
          * checks if the currently edited curriculum has questions with linked questions of type 'Excludeon'
          */
         cur_c_has_exclusion_q(){
            let questions = this.editedItem_c.questions;


            for (let i=0; i<questions.length; i++){

               //  let Q = this.findWithAttr(this.questions, '_id', questions[i].q_id, true);

                let ix = this.get_q_ix(questions[i].q_id);
                let Q = this.questions[ix];

                if (Q != null && Q.linked_questions != null){
                   if (Q.linked_questions.link_type === 'ExcludeOn' || Q.linked_questions.link_type === 'DependsOn'){
                      this.ignore_weight_check = true;
                      return true;
                   }
                }
            }
            this.ignore_weight_check = false;
            return false;
         },

      },


      created(){
         // let data = await Promise.all([this.get_questions(), this.get_curricula()]);
         // this.questions = data[0];
         // this.curricula = data[1];

         this.get_questions_local();
         // this.get_questions().then(data =>{
         //    this.questions = data;
         // });


         this.data_loading_c = true;
         this.get_curricula({get_rc_data: true}).then(data => {
            this.curricula = data;
            this.data_loading_c = false;
         });



         for (let i=0; i<=100; i++){
            this.score_list.push(i);
         }

      }



   };
</script>
